import { render } from "./HistoryFilter.vue?vue&type=template&id=1a845aa8"
import script from "./HistoryFilter.vue?vue&type=script&lang=js"
export * from "./HistoryFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__